"use strict";

exports.__esModule = true;
exports.default = void 0;

var _embed = _interopRequireDefault(require("./embed"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BEmbed: _embed.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/embed/index.js
// module id = 488
// module chunks = 7